<template>
    <div class="p-1 flex flex-col items-start">
        <button class="border mb-2 py-1 px-2 " @click="mode = 0" v-if="mode != 0">返回</button>
        <div class="w-full flex flex-col items-start" v-if="mode == 0">
            <p class="text-xs text-center w-full font-bold">已收集个人信息</p>
            <div class="mb-2">
                时间跨度：
                <select v-model="date" class="border">
                    <option value="1">7天</option>
                    <option value="2">1个月</option>
                    <option value="3">3个月</option>
                </select>
            </div>
    
            <div @click="mode = 1" class="border mb-1 rounded-sm p-2 w-full">用户账号信息</div>
            <div @click="mode = 2" class="border mb-1 rounded-sm p-2 w-full">用户交易信息</div>
            <div @click="mode = 3" class="border mb-1 rounded-sm p-2 w-full">用户使用过程信息</div>
            <div @click="mode = 4" class="border mb-1 rounded-sm p-2 w-full">设备属性信息</div>
        </div>


        <div v-if="mode == 1">
            <table class=" border">
                <tr class="border">
                    <th class="border py-1.5 w-10">信息名称</th>
                    <th class="border py-1.5">使用目的</th>
                    <th class="border py-1.5">使用场景</th>
                    <th class="border py-1.5">收集情况</th>
                    <th class="border py-1.5">信息内容</th>
                </tr>
                <tr class="border" v-for="(i,index) in data1" :key="index">
                    <td class="border px-2 py-1.5">{{i.name}}</td>
                    <td class="border px-2 py-1.5">{{i.purpose}}</td>
                    <td class="border px-2 py-1.5">{{i.scene}}</td>
                    <td class="border px-2 py-1.5">{{i.status}}</td>
                    <td  class="border px-2 py-1.5">
                        {{i.content}}
                    </td>
                </tr>
            </table>
        </div>
        <div v-if="mode == 2">
            <table class="border">
                <tr class="border">
                    <th class="border py-1.5 w-10">信息名称</th>
                    <th class="border py-1.5">使用目的</th>
                    <th class="border py-1.5">使用场景</th>
                    <th class="border py-1.5">收集情况</th>
                    <th class="border py-1.5">信息内容</th>
                </tr>
                <tr class="border" v-for="(i,index) in data2" :key="index">
                    <td class="border px-2 py-1.5">{{i.name}}</td>
                    <td class="border px-2 py-1.5">{{i.purpose}}</td>
                    <td class="border px-2 py-1.5">{{i.scene}}</td>
                    <td class="border px-2 py-1.5">{{i.status}}</td>
                    <td  class="border px-2 py-1.5">
                        {{i.content}}
                    </td>
                </tr>
            </table>
            
        </div>
        <div v-if="mode == 3">
            <table class=" border">
                <tr class="border">
                    <th class="border py-1.5 w-10">信息名称</th>
                    <th class="border py-1.5">使用目的</th>
                    <th class="border py-1.5">使用场景</th>
                    <th class="border py-1.5">收集情况</th>
                    <th class="border py-1.5">信息内容</th>
                </tr>
                <tr class="border" v-for="(i,index) in data3" :key="index">
                    <td class="border px-2 py-1.5">{{i.name}}</td>
                    <td class="border px-2 py-1.5">{{i.purpose}}</td>
                    <td class="border px-2 py-1.5">{{i.scene}}</td>
                    <td class="border px-2 py-1.5">{{i.status}}</td>
                    <td  class="border px-2 py-1.5">
                        {{i.content}}
                    </td>
                </tr>
            </table>
            
        </div>
        <div v-if="mode == 4">
            <table class="border">
                <tr class="border">
                    <th class="border py-1.5 w-10">信息名称</th>
                    <th class="border py-1.5">使用目的</th>
                    <th class="border py-1.5">使用场景</th>
                    <th class="border py-1.5">收集情况</th>
                    <th class="border py-1.5">信息内容</th>
                </tr>
                <tr class="border" v-for="(i,index) in data4" :key="index">
                    <td class="border px-2 py-1.5">{{i.name}}</td>
                    <td class="border px-2 py-1.5">{{i.purpose}}</td>
                    <td class="border px-2 py-1.5">{{i.scene}}</td>
                    <td class="border px-2 py-1.5">{{i.status}}</td>
                    <td class="border px-2 py-1.5" v-html="i.content"></td>
                </tr>
            </table>

        </div>
    </div>
</template>

<script>
import Xc from "../../js/xinchao"
export default {
    data(){
        return {
            date:"1",
            mode:0,
            data1:[
                {name:"昵称",	purpose:"获取用户昵称，完善网络身份标识",	scene:"我的页面展示",status:"已收集",content:"请查看“我的 - 设置”页面"},
                {name:"头像",	purpose:"获取用户头像，完善网络身份标识",	scene:"我的页面展示",status:"已收集",content:"请查看“我的 - 设置”页面"},
                {name:"简介",	purpose:"完善账号基本资料",	scene:"我的页面展示",status:"已收集",content:"请查看“我的 - 设置”页面"},
                {name:"性别",	purpose:"完善账号基本资料",	scene:"我的页面展示",status:"已收集",content:"请查看“我的 - 设置”页面"},
                {name:"生日",	purpose:"完善账号基本资料",	scene:"我的页面展示",status:"已收集",content:"请查看“我的 - 设置”页面"},
                {name:"手机号",	purpose:"注册/登录心潮账号；实名认证",	scene:"注册/登录账号；进行实名认证/身份验证",status:"已收集",content:"请查看“我的 - 设置”页面"},
                {name:"第三方应用",	purpose:"绑定第三方账号进行快捷登录",	scene:"使用第三方账号快捷登录",status:"已收集",content:"请查看“我的 - 设置”页面"},

            ],
            data2:[
                {name:"会员购买记录",purpose:"用于展示用户会员购买记录",scene:"客服售后；会员购买信息查询",status:"已收集",content:"请查看”我的 - 会员中心 - 购买记录“页面"},
                {name:"心贝充值记录",purpose:"用于展示用户心贝充值记录",scene:"客服售后；心贝购买信息查询",status:"已收集",content:"请查看”我的 - 我的钱包 - 充值记录“页面"},
                {name:"商品购买记录",purpose:"用于展示用户商品购买记录",scene:"客服售后；商品购买信息查询",status:"已收集",content:"请查看”我的 - 已购买项目“页面"},
            ],
            data3:[

                {name:"个人消息",	purpose:"用于展示用户接收系统推送的通知",	scene:"个人消息功能",	status:"已收集",	content:"请查看“我的 - 消息中心”页面"},
                {name:"客服反馈",	purpose:"用于收集用户反馈/问题",	scene:"收集用户反馈/问题",	status:"已收集",	content:"请查看“我的 - 帮助与反馈”页面"},
                {name:"心肺压力改善报告",	purpose:"为用户分析心肺压力",	scene:"心肺压力改善功能",	status:"已收集",	content:"请查看“心潮首页 - 心肺压力改善 - 历史记录”页面"},
                {name:"深度推荐",	purpose:"为用户定制恢复精力方案",	scene:"深度推荐功能",	status:"已收集",	content:"请查看“我的 - 深度推荐”页面"},

            ],
            data4:[
                {name:"IMEI",	purpose:"安全风控、广告投放",	scene:"APP安全运行、风险检测与控制、广告投放",	status:"已收集",	content:"35936705<br/>4667238"},
                {name:"MAC",	purpose:"安全风控、广告投放",	scene:"APP安全运行、风险检测与控制、广告投放",	status:"已收集",	content:"00:A0:C9:<br/>14:C8:29"},
                {name:"OAID",	purpose:"安全风控、广告投放",	scene:"每次APP启动时、展示广告时、搜索时、登录时、APP后台切前台时",	status:"已收集",	content:"E6E83E8D3B7D43<br/>75B2430F7CEBC6C8631<br/>215d251467eb9894a77<br/>c3674543b789"},
                {name:"Android_ID",	purpose:"安全风控、广告投放",	scene:"每次APP启动时、展示广告时、搜索时、登录时、APP后台切前台时",	status:"已收集",	content:"41325e362e2b44bf"},
                {name:"IDFA",	purpose:"安全风控、广告投放",	scene:"每次APP启动时、展示广告时、搜索时、登录时、APP后台切前台时",	status:"已收集",	 content:"B7169095-4B23<br/>-49F6A-791*****"},
                {name:"IMSI",	purpose:"安全风控、广告投放",	scene:"每次APP启动时、展示广告时、搜索时、登录时、APP后台切前台时",	status:"已收集",	content:"460001234567890"},
                {name:"SIM卡",	purpose:"安全风控、广告投放",	scene:"每次APP启动时、展示广告时、搜索时、登录时、APP后台切前台时",	status:"已收集",	content:"8986049912<br/>3456789012"},
                {name:"分辨率",	purpose:"安全风控、兼容性等问题分析",	scene:"APP安全运行、风险检测与控制、功能兼容性分析",	status:"已收集",	content:"2772*1240"},
                
                {name:"网络类型",	purpose:"安全风控、兼容性等问题分析",	scene:"APP安全运行、风险检测与控制、功能兼容性分析",	status:"已收集",	content:"WIFI"},
                {name:"系统剪切板",	purpose:"内容粘贴",	scene:"每次用户参与文字口令活动/发布动态、评论等内容时",	status:"已收集",	content:"文字内容"},
                {name:"网络运营商",	purpose:"安全风控、兼容性等问题分析",	scene:"APP安全运行、系统错误排查、功能兼容性分析",	status:"已收集",	content:"CTCC"},

                // {key:"imsi",name:"IMSI",	scene:"每次APP启动时、展示广告时、搜索时、登录时、APP后台切前台时",	purpose:"安全风控、广告投放",status:"已收集",content:""},
                // {key:"sSimSerialNumber",name:"SIM卡",	scene:"每次APP启动时、展示广告时、搜索时、登录时、APP后台切前台时",	purpose:"安全风控、广告投放",status:"已收集",content:""},
                // {key:"imei",name:"IMEI",	purpose:"安全风控、广告投放",	scene:"APP安全运行、风险检测与控制、广告投放",status:"已收集",content:""},
                // {key:"mac",name:"MAC",	purpose:"安全风控、广告投放",	scene:"APP安全运行、风险检测与控制、广告投放",status:"已收集",content:""},
                // {key:"oaid",name:"OAID",	purpose:"安全风控、广告投放",	scene:"每次APP启动时、展示广告时、搜索时、登录时、APP后台切前台时",status:"已收集",content:""},
                // {key:"android_id",name:"Android_ID",	purpose:"安全风控、广告投放",	scene:"每次APP启动时、展示广告时、搜索时、登录时、APP后台切前台时",status:"已收集",content:""},
                // {key:"idfa",name:"IDFA",	purpose:"安全风控、广告投放",	scene:"每次APP启动时、展示广告时、搜索时、登录时、APP后台切前台时",status:"已收集",content:""},
                // {key:"resolution",name:"分辨率",	purpose:"安全风控、兼容性等问题分析",	scene:"APP安全运行、风险检测与控制、功能兼容性分析",status:"已收集",content:""},
                // {key:"brand",name:"硬件品牌",	purpose:"安全风控、兼容性等问题分析",	scene:"APP安全运行、风险检测与控制、功能兼容性分析",status:"已收集",content:""},
                // {key:"net_type",name:"网络类型",	purpose:"安全风控、兼容性等问题分析",	scene:"APP安全运行、风险检测与控制、功能兼容性分析",status:"已收集",content:""},
                // {name:"系统剪切板",	purpose:"内容粘贴",	scene:"每次用户参与文字口令活动；发布动态、评论等内容时",status:"已收集",content:"文字内容"},
                // {key:"t_mobile",name:"网络运营商",	purpose:"安全风控、兼容性等问题分析",	scene:"APP安全运行、系统错误排查、功能兼容性分析",status:"已收集",content:""},

            ],
        }
    },
    created(){
        this.getDeviceInfo()
    },
    mounted(){

    },
    methods:{
        getDeviceInfo(){
            const isIos = /iphone|ipad|mac os/.test(navigator.userAgent.toLowerCase())
            Xc.callAppRouter("devicesInfo",{},(err,res)=>{
                console.log("设备信息：",res);
                const response = isIos?JSON.parse(res):res
                if(response.status == 1){
                    const data = response.data
                    this.data4.forEach(i=>{
                        if(i.key){
                            if(data[i.key]){
                                const content = this.insertBreaks(data[i.key])
                                i.content = content
                            }else{
                                i.content = "/"
                            }
                        }
                    })
                }
            })

        },
        jump(config){
            Xc.callAppRouter("Redirect",config,()=>{})
        },
        insertBreaks(str) {
            let result = '';
            for (let i = 0; i < str.length; i += 10) {
                result += str.slice(i, i + 10) + '<br/>';
            }
            return result;
        }
    },
}
</script>

<style lang='scss' scoped>

</style>